import React, {useCallback, useEffect, useRef, useState} from "react";
import {
    Card,
    Page,
    Layout,
    FormLayout,
    Tooltip,
    Checkbox,
    Divider,
    Text,
    TextField,
    LegacyStack,
    Thumbnail,
    DropZone,
    LegacyCard,
    Tag,
    Button,
    ContextualSaveBar,
    Select,
    Modal,
    Link,
    Badge, Banner, Spinner
} from "@shopify/polaris";
import Alert from "../../Lib/Alert";
import Http from "../../Lib/Http";
import {useGoTo} from "../../Lib/useGoTo";
import { NoteMajor} from "@shopify/polaris-icons";
import CTableEditor from "@admin/pages/Chart/CTableEditor";
import {Cell, Chart, Product} from "@admin/types";
import {useParams} from "react-router-dom";
import CriticalError from "@admin/components/CriticalError";
//import Menu from "@admin/Lib/Menu";

function ChartForm() {
    const [chartCount, setChartCount] = useState<number>(0);
    const [legacy, setLegacy] = useState<number>(1);
    const [free, setFree] = useState<number>(0);
    const [ignoreTagChange, setIgnoreTagChange] = useState(true);
    const [importActive, setImportActive] = useState(false);
    const [cssActive, setCssActive] = useState(false);
    const [productModalActive, setProductModalActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formChanged, setFormChanged] = useState(false);
    const [importError, setImportError] = useState(false);
    const [imageError, setImageError] = useState<string | undefined>(undefined);
    const goTo = useGoTo();
    const [newTag, setNewTag] = useState<string>('');
    const [file, setFile] = useState<File>();
    const [fileImport, setFileImport] = useState<File>();
    const [selectedTags, setSelectedTags] = useState<string[]>([]);
    const [ogTags, setOgTags] = useState<string[]>([]);
    const [products, setProducts] = useState<Product[]>([]);
    const [error, setError] = useState<string | undefined>('');
    const [customCss, setCustomCss] = useState<string>('');
    const routeParams = useParams();
    const [showBilling, setShowBilling] = useState(true);
    const [cssError, setCssError] = useState<string | undefined>(undefined);
    const [titleError, setTitleError] = useState<string | undefined>(undefined);
    const [generalError, setGeneralError] = useState(false);
    const chartId = routeParams.chartID;
    const myRef = useRef<HTMLDivElement>(null);
    const blankChart = {
        id: null,
        title: '',
        tag: [],
        data: [
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
            [{ type: "text", value: "" }, { type: "text", value: "" }, { type: "text", value: "" }],
        ],
        top: false,
        bottom: false,
        left: false,
        right: false,
        enabled: true,
        universal: false,
        text1: "",
        text2: "",
        user_id: null,
        created_at: null,
        updated_at: null,
        download_key: null,
        image_key: null,
        image_position: undefined,
        image_public_url: null,
        locked: 0
    };


    const [chartOgCopy, setChartOgCopy] = useState<Chart>(blankChart);
    const [chart, setChart] = useState<Chart>(blankChart);


    const removeTag = useCallback(
        (tag: string) => () => {
            setSelectedTags((previousTags) =>
                previousTags.filter((previousTag) => previousTag !== tag),
            );
        },
        [],
    );

    const handleImagePosition = useCallback(
        (value: string) => handleChartChange('image_position', value),
        [],
    );

    const handleCssChange = useCallback(
        (newValue: string) => setCustomCss(newValue),
        [],
    );

    const handleDropZoneDrop = useCallback(
        (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) =>
            setFile(acceptedFiles[0]),
        [],
    );

    const handleDropZoneDropImport = useCallback(
        (_dropFiles: File[], acceptedFiles: File[], _rejectedFiles: File[]) =>
            setFileImport(acceptedFiles[0]),
        [],
    );
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];

    const fileUpload = !file && <DropZone.FileUpload />;
    const fileUploadImport = !fileImport && <DropZone.FileUpload />;
    const uploadedFile = file && (
        <LegacyStack>
            <Thumbnail
                size="small"
                alt={file.name}
                source={
                    chart.image_public_url
                        ? chart.image_public_url
                        : NoteMajor
                }
            />
            <div>
                {file.name}{' '}
                <Text variant="bodySm" as="p">
                    {file.size} bytes
                </Text>
            </div>
        </LegacyStack>
    );

    const uploadedFileImport = fileImport && (
        <LegacyStack>
            <Thumbnail
                size="small"
                alt={'file'}
                source={ NoteMajor }
            />
            <div>
                {fileImport.name}{' '}
                <Text variant="bodySm" as="p">
                    {fileImport.size} bytes
                </Text>
            </div>
        </LegacyStack>
    );



    useEffect(() => {
        if (chartId) {
            setIgnoreTagChange(false);
            fetchChart(chartId)
        } else {
            setLoading(false);
        }
    }, [chartId]);

    useEffect(() => {
        if(file){
            uploadFile();
        }
    }, [file]);

    useEffect(() => {
        if(fileImport){
            uploadImportFile();
        }
    }, [fileImport]);


    useEffect(() => {
        if(ignoreTagChange){
            return;
        }
        handleChartChange('tag', selectedTags);

    }, [selectedTags]);


    useEffect(() => {
       getShops();
    }, []);

    useEffect(() => {
        if (free == 1){

            let css = '.Polaris-BlockStack>li:nth-child(1) .Polaris-ActionList__Item,.Polaris-BlockStack>li:nth-child(2) .Polaris-ActionList__Text{color:var(--p-color-text-disabled)!important;}';
            const styleElement = document.createElement('style');
            styleElement.type = 'text/css';
            styleElement.appendChild(document.createTextNode(css));

            window.document.head.appendChild(styleElement);
        }
    }, [free]);


    const html = {
        escape: (unsafe: string): string => {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        },

        unescape: (safe: string): string => {
            const div = document.createElement("div");
            div.innerHTML = safe;
            return div.innerText || div.textContent || ""; // Adjusted for potential null value
        },
    };

    const fromDbCell = (cell: string): Cell => {
        const textRegExp = new RegExp(/^<span class="esc-size-guide--cell-type--text">(.*)<\/span>$/);
        if (textRegExp.test(cell)) return { type: "text", value: html.unescape(cell.match(textRegExp)![1]) }; // Non-null assertion for match result

        const dressRegExp = new RegExp(/^<span class="esc-size-guide--cell-type--dress">(.*)<\/span>$/);
        if (dressRegExp.test(cell)) return { type: "dress", value: html.unescape(cell.match(dressRegExp)![1]) }; // Non-null assertion for match result

        const imgRegExp = new RegExp(/^<img class="esc-size-guide--cell-type--img" src="(.*)"\/>$/);
        if (imgRegExp.test(cell)) return { type: "img", value: cell.match(imgRegExp)![1] }; // Non-null assertion for match result

        return { type: "html", value: cell };
    };

    const toDbCell = (cell: Cell): string => {
        if (cell.type == "text") return `<span class="esc-size-guide--cell-type--text">${html.escape(cell.value)}</span>`;

        if (cell.type == "dress") return `<span class="esc-size-guide--cell-type--dress">${html.escape(cell.value)}</span>`;

        if (cell.type == "img") return `<img class="esc-size-guide--cell-type--img" src="${cell.value}"/>`;

        return cell.value;
    };

    const fetchChart = ( id:string) => {
        Http.get(`/app/api/v1/charts/${id}.json`, )
            .then((response) => {
                const data = response.data;
                let tmpChart = data.chart;
                tmpChart.data = (tmpChart.data || []).map((row: any[]) => row.map((cell) => fromDbCell(cell)));
                setSelectedTags(data.chart.tag);
                setOgTags(data.chart.tag);
                setChart(tmpChart);
                setChartOgCopy(tmpChart);
                setFormChanged(false);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setFormChanged(false);
            })
            .finally(() => {setTimeout(function() { setFormChanged(false); }, 100);
            });
    };

    const openSupport = () => {
        window.open('mailto:support@eastsideco.com', '_blank');
    };

    const uploadFile = () => {
        if (!file || !chartId) {
             setImageError('Please save your chart first')
            console.log("File or ID is missing!");
            return;
        }else{
            setImageError(undefined);
        }

        const formData = new FormData();
        formData.append("file", file);
        setLoading(true);
        Http.post(`/app/api/v1/charts/image/${chartId}`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then((res) => {
                handleChartChange('image_position', 'top');
                handleChartChange('image_public_url', res.data.image_public_url);
                setChartOgCopy(chart);
                setFormChanged(false);
                setLoading(false);
                Alert.success("Image uploaded");
             })
            .catch(() => {
                setImageError('Image upload failed, check image format')
                setLoading(false);
                console.log("The image could not be uploaded!");
            });
    };


    const uploadImportFile = () => {
        setImportError(false);

        if (!fileImport) {
            return;
        }

        const formData = new FormData();
        formData.append("file", fileImport);


        if (chartId) {
            Http
                .post(`/app/api/v1/charts/${chartId}/import`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(() => {
                    fetchChart(chartId);
                    setImportActive(false);
                    Alert.success("csv successfully imported." );
                })
                .catch(() => {
                    setImportError(true);
                });
        } else {
            Http
                .post(`/app/api/v1/charts/import`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((res) => {
                    if (res.data) {
                        let tmpChart = res.data.data;
                        let data = (tmpChart || []).map((row: any[]) => row.map((cell) => fromDbCell(cell)));
                        handleChartChange('data', data);
                        setImportActive(false);
                        Alert.success("csv successfully imported" );
                    }
                    if (res.data && res.data.image) {
                        if (res.data && res.data.image) {
                            handleChartChange('image_public_url', res.data.image);
                        }
                    }
                })
                .catch(() => {
                    setImportError(true);
                });
        }
    };


    const getShops = () => {
        Http.get(`/app/api/v1/shop.json?charts=1`)
            .then((response) => {
                let shop = response.data.shop
                setChartCount(response.data.charts);
                setLegacy(shop.legacy);
                setFree(shop.free);
                setCustomCss(shop.custom_css);
             //   Menu.loadMenu(shop);
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    };


    const handleTableChange = (data: Cell[][]) => {
        handleChartChange('data', data);
     };


    const handleAddTag = () => {
        setError('');
        setIgnoreTagChange(false);

        if (!newTag) {
            return setError('Field required');
        }
        if (selectedTags.includes(newTag)) {
            return setError('Cannot add duplicate tag');
        }

        setSelectedTags([...selectedTags, newTag]);

        setNewTag('');
    };
    const handleKeyPress = (event: React.KeyboardEvent) => {
        const enterKeyPressed = event.key === 'Enter';
        if (enterKeyPressed) {
            event.preventDefault();
            handleAddTag();
        }
    }

    const handleTextTagFieldChange = useCallback(
        (value: string) => setNewTag(value),
        [],
    );

    const handleChartChange = (name : string, inputValue :  null|undefined|string|boolean|string[]|Cell[][]) => {
         setChart((prevChart: Chart) => {
             const updatedChart = { ...prevChart };

             const keys = name.split('.');
            let current: any = updatedChart;
            for (let i = 0; i < keys.length - 1; i++) {
                const key = keys[i];
                if (current[key] === undefined) current[key] = {};
                current = current[key];
            }

             const lastKey = keys[keys.length - 1];
            current[lastKey] = inputValue;

            return updatedChart;
        });
        setFormChanged(true);
        setIgnoreTagChange(false);
    };
    const discard = () => {
        setChart(chartOgCopy);
        setSelectedTags(ogTags);
        setGeneralError(false);
        setError('');
        setTitleError(undefined);
        setTimeout(function() { setFormChanged(false); }, 100);
    };
    const deleteImage = () => {
        setImageError(undefined);
        if (chart.image_public_url) {
            Http
                .delete(`/app/api/v1/charts/image/${chartId}`)
                .then((res) => {
                    Alert.success("image successfully removed");
                    handleChartChange('image_position', undefined);
                    handleChartChange('image_public_url',null);
                    setChartOgCopy(chart);
                    setFormChanged(false);
                })
                .catch(() => {
                    setImageError('The image could not be removed');
                });
        }
    };
    const saveChart = () => {
        setGeneralError(false);
        if (!chart.title.trim()) {
            setTitleError('Title field is required');
            window.scrollTo({ top: 0, behavior: 'smooth' });
            return;
        }else{
            setTitleError(undefined);
        }
        if (chartId){

          if (chart.tag.length <= 0 && !chart.universal) {
              setError('Add tags or select display on all option')
              if(myRef){
                  myRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              return;
          }else{
              setError('');
          }

           setLoading(true);

          Http.put(`/app/api/v1/charts/${chartId}.json`, {chart :  getDbChart()})
              .then((res) => {
                  setChartOgCopy(chart);
                  setFormChanged(false);
                  setLoading(false);
                  Alert.success('Chart saved');
              })
              .catch((e) => {
                  setLoading(false);
                 // Alert.error('There was an error, please contact support');
                  setGeneralError(true)
                  window.scrollTo({ top: 0, behavior: 'smooth' });
              });
      }else {
            if (chart.tag.length  ==   0 && !chart.universal ) {
                setError('Add tags or select display on all option')
                if(myRef){
                    myRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
                return;
            }else{
                setError('');
            }

            setLoading(true);
            console.log({chart :  getDbChart(), image_position : chart.image_position, image_public_url : chart.image_public_url});
            Http.post(`/app/api/v1/charts.json`, {chart :  getDbChart(), image_public_url : chart.image_public_url})
                .then((res) => {
                    Alert.success('Chart saved');
                    setLoading(false);
                    let createdChartId = res.data.chart.id;
                    goTo('/charts/'+createdChartId)
                })
                .catch((e) => {
                    setLoading(false);
                    setGeneralError(true)
                    window.scrollTo({ top: 0, behavior: 'smooth' });

                });
      }
    };

    const getDbChart = () => {
        let data = {
            id: chart.id,
            tag: `,${chart.tag.join(",")},`,
            title: chart.title,
            data: chart.data.map((row) => row.map((cell) => toDbCell(cell))),
            top: chart.top,
            bottom: chart.bottom,
            left: chart.left,
            right: chart.right,
            enabled: chart.enabled,
            universal: chart.universal,
            text1: chart.text1,
            text2: chart.text2,
            image_position: chart.image_position,
        };
        return data;
    };

    const duplicate = () => {
        if (legacy == 0 && free == 1 && chartCount >= 3) {
             return;
        }
        setLoading(true);

        Http.post(`/app/api/v1/charts/${chartId}/duplicate.json`).then((res) => {
            Alert.success("Chart duplicated");
            setLoading(false);
            let clonedId = res.data.chart.id;
            goTo('/charts/'+clonedId)
            //window.scrollTo(0, 0);
        });
    };


    const exportChart = () => {
        if (legacy == 1 || free == 0) {
            Http.get(`/app/api/v1/charts/${chartId}/export`).then((res) => {
                window.open(res.data.link);
            });
        }else{
            setImportActive(true);
            return;
        }
    };

    const importChart = () => {
        setImportActive(true);
    };

    const deleteChart = () => {
        if(chartId){
            Http.delete(`/app/api/v1/charts/${chartId}`).then(() => {
                Alert.success("Chart deleted");
                goTo('/');
            });
        }
    };
    const saveCss = () => {
        setCssError(undefined);
        Http
            .post("/app/api/v1/shop/css", { css: customCss })
            .then((res) => {
                Alert.success("Custom CSS updated");
                setCssActive(false);
            })
            .catch((e) => {
                setCssError('Css update failed, please check your css');
            });
    };

    const seeProductsByTags = () => {
        Http
            .post("/app/api/v1/tag-products", { tags: selectedTags.join(",") })
            .then((res) => {
                setProductModalActive(true);
               setProducts(res.data.products);
            })
            .catch((e) => {
                //  Toast.create(app, { message: "Could not update Custom CSS.", isError: true }).dispatch(Toast.Action.SHOW);
            });
    };

    const [checked, setChecked] = useState(false);
    const handleCheckboxChange = useCallback(
        (newChecked: boolean) => setChecked(newChecked),
        [],
    );


    const pageActions =  undefined;

    const additionalActions = chartId ? [
        {
            title: 'Actions',
            actions: [
                {
                    content: 'Import',
                    accessibilityLabel: 'Import a chart',
                    onAction: () => {importChart()},
                },
                {
                    content: 'Export',
                    accessibilityLabel: 'Export a chart',
                    onAction: () => {exportChart()},
                },
                {
                    content: 'Duplicate',
                    accessibilityLabel: 'Duplicate a chart',
                    disabled: (legacy == 0 && free == 1 && chartCount >= 3),
                    onAction: () => duplicate(),
                },
                {
                    content: 'Add CSS',
                    accessibilityLabel: 'Individual action label',
                    onAction: () => setCssActive(true),
                },
                {
                    content: 'Delete',
                    accessibilityLabel: 'Individual action label',
                    destructive: true,
                    onAction: () => deleteChart(),
                },
            ],
        },
    ] :  [
        {
            title: 'Actions',
            actions: [
                {
                    content: 'Import',
                    accessibilityLabel: 'Import a chart',
                    onAction: () => {importChart()},
                }
            ],
        },
    ];

    return (
        <Page
            backAction={{
                content: 'Home', onAction() {
                    goTo('')
                }
            }}
            title={chartId ? chart.title ? chart.title : "Edit size chart" : "Create new size chart"}
            secondaryActions={pageActions}
            titleMetadata={chart.enabled && (selectedTags.length > 0 || chart.universal) ?
                <Badge tone="success">Active</Badge> : <Badge tone="info">Draft</Badge>}
            actionGroups={additionalActions}
        >
            {formChanged &&
                <ContextualSaveBar
                    message={chartId ? "Unsaved changes" : "Save new chart"}
                    saveAction={{
                        onAction: () => saveChart(),
                        loading: loading,
                        disabled: loading,
                    }}
                    discardAction={{
                        onAction: () => discard(),
                    }}
                />
            }
            <Modal
                open={importActive}
                onClose={() => {
                    setImportActive(false)
                }}
                title={free == 1 ? "" : "Import charts"}
            >
                <Modal.Section>
                    {free == 0 &&
                        <>
                            <p>
                                Do you already have your chart info in a .csv file with a header row and the
                                variable
                                data in columns? You can import it directly into Size Matters!
                                If you have any problems importing your file, contact support@eastsideco.com
                                <br/>
                                <br/>
                            </p>
                            <DropZone allowMultiple={false} onDrop={handleDropZoneDropImport}>
                                {uploadedFileImport}
                                {fileUploadImport}
                            </DropZone>
                            {importError &&
                                <div className="Polaris-Labelled__Error">
                                    <div id=":r4k:Error" className="Polaris-InlineError">
                                        <div className="Polaris-InlineError__Icon"><span className="Polaris-Icon"><svg
                                            viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false"
                                            aria-hidden="true"><path
                                            d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z"></path><path
                                            d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path><path fill-rule="evenodd"
                                                                                                 d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"></path></svg></span>
                                        </div>
                                        File upload or processing error. Please check the file correctly formated
                                    </div>
                                </div>
                            }
                        </>
                    }
                    {free == 1 &&
                        <div className="nbis-center">
                            You have discovered a premium feature 👀
                            <br/>
                            This feature is only available on the premium plan. Please upgrade to enable this
                            feature'
                            <br/><br/>
                            <Button onClick={() => {
                                goTo('/wizard/2?upgrade=1')
                            }} variant="primary">Upgrade</Button>
                        </div>
                    }
                </Modal.Section>
            </Modal>
            <Modal
                open={cssActive}
                onClose={() => {
                    setCssActive(false)
                }}
                title="Custom CSS"
            >
                <Modal.Section>
                    <>
                        <p>
                            Add custom styling to the elements of size guides and charts with CSS. We recommend you
                            contact our support team for assistance if you’re not experienced with using CSS. Any
                            custom CSS will be minified to improve speed and efficiency.
                            <br/>
                            <br/>
                            Custom CSS will be added globally and may affect all size guides and charts
                            <br/>
                            <br/>
                        </p>
                        <div>
                            <TextField
                                name="css"
                                type="text"
                                label=""
                                error={cssError}
                                multiline={5}
                                value={customCss}
                                onChange={handleCssChange}
                                autoComplete="off"
                            />
                        </div>
                        <div style={{textAlign: 'right'}} className="mt-20">
                            <Button variant="primary" onClick={saveCss}>Save</Button>
                        </div>
                    </>
                </Modal.Section>
            </Modal>
            <Modal
                open={productModalActive}
                onClose={() => {
                    setProductModalActive(false)
                }}
                title="Products with matching tags"
            >
                <Modal.Section>
                    <>
                        <div>
                            <div className="modalBody">
                                {products.length > 0 ? (
                                    <p>
                                        When the app widget is installed correctly, then this size guide will appear on
                                        your store front for the products below:
                                    </p>
                                ) : (
                                    <p>
                                        There are no products associated with the tag(s) for this size guide. <br/>
                                        Please make sure that the size guide tags are an exact match to the product
                                        tags.
                                    </p>
                                )}
                                <ul>
                                    {products.map(product => (
                                        <li key={product.id}>
                                            <a href={product.handle} target="_blank" rel="noopener noreferrer">
                                                {product.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </>
                </Modal.Section>
            </Modal>
            {generalError &&
                <div>
                    <CriticalError onDismiss={() => {
                        setGeneralError(false)
                    }} showAlert={generalError} title={'Error saving chart'}/>
                </div>
            }
            {(legacy == 0 && free == 1 && chartCount >= 3 && showBilling) &&
                <Layout>
                    <Layout.Section>
                        <div style={{paddingBottom: '20px', marginBottom: '20px'}}>
                                <Banner
                                    title="Size guide limit reached"
                                    tone="warning"
                                    action={{
                                        content: 'Go to billing', onAction() {
                                            goTo('/wizard/2?upgrade=1');
                                        }
                                    }}
                                >
                                    <p>
                                        You won't be able to add anymore size guides or charts on the free plan.
                                        Upgrade to premium to have unlimited size guides and charts.
                                        <br/>
                                    </p>
                                </Banner>

                            </div>
                        </Layout.Section>
                    </Layout>
                }
                {loading &&
                    <div>
                        <Spinner accessibilityLabel="Spinner example" size="large"/>
                    </div>
                }
                <Layout>
                    <Layout.AnnotatedSection
                        id="SizeChartdetails "
                        title="Size Chart details"
                        description="You can give your chart a title so if you have more than one size chart, they’re easier to manage. To make the chart visible to your customers, tick the Display Size Chart box."
                    >
                        <Card>
                            <FormLayout>
                                <FormLayout.Group>
                                    <TextField
                                        name="title"
                                        type="text"
                                        error={titleError}
                                        label="Title"
                                        value={chart.title}
                                        onChange={(newValue) => {
                                            handleChartChange('title', newValue);
                                            if (!newValue.trim()) {
                                                setTitleError('Title field is required');
                                            }else{
                                                setTitleError(undefined);
                                            }
                                        }}
                                        autoComplete="off"
                                    />
                                </FormLayout.Group>
                                <FormLayout.Group>
                                    <Checkbox
                                        name="enabled"
                                        label="Display size chart "
                                        checked={chart.enabled}
                                        onChange={(newValue) => {
                                            handleChartChange('enabled', newValue);
                                        }}
                                    />
                                </FormLayout.Group>
                                <Divider borderColor="border"/>
                                <Text variant="headingSm" as="h6">
                                    Description
                                </Text>
                                <p>
                                    You can add a description above and below your chart to provide your customers with
                                    more information. This is useful if your sizes are approximate, or if there are any
                                    other messages that you want to include.
                                </p>
                                <FormLayout.Group>
                                    <div style={{display: 'flex', alignItems: 'center'}}>
                                        <div style={{flex: 1, marginRight: '10px'}}>
                                            <TextField
                                                value={chart.text1}
                                                multiline={5}
                                                type="text"
                                                name="text1"
                                                placeholder={'Type the description here'}
                                                label="Above the table"
                                                onChange={(newValue) => {
                                                    handleChartChange('text1', newValue);
                                                }}
                                                autoComplete="off"
                                            />
                                        </div>
                                        <div style={{flex: 1}}>
                                            <TextField
                                                name="text2"
                                                value={chart.text2}
                                                multiline={5}
                                                placeholder={'Type the description here'}
                                                type="text"
                                                label="Below the table"
                                                onChange={(newValue) => {
                                                    handleChartChange('text2', newValue);
                                                }}
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </FormLayout.Group>
                            </FormLayout>
                            <div ref={myRef}></div>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="Tags "
                        title="Tags"
                        description="Each size chart is attached to your products by using tags. "
                    >
                        <Card>
                            <div onKeyDown={handleKeyPress}>
                                <Tooltip
                                    content={newTag == '' ? 'Start typing to add a tag' : 'Hit enter to add ' + newTag}
                                    dismissOnMouseOut>

                                    <TextField
                                        value={newTag}
                                        onChange={handleTextTagFieldChange}
                                        autoComplete="off"
                                        connectedRight={
                                            <Button onClick={handleAddTag}>
                                                Add
                                            </Button>
                                        }
                                        label=""
                                        error={error}/>
                                </Tooltip>
                            </div>
                            <br/>
                            <LegacyStack spacing="tight">
                                {selectedTags.map((option: unknown, index: number) => {
                                    const optionValue = option as string;
                                    return (
                                        <Tag
                                            key={index}
                                            onRemove={removeTag(optionValue)}>
                                            {optionValue}
                                        </Tag>
                                    );
                                })}
                            </LegacyStack>
                            <LegacyStack spacing="tight">
                                <div className="mt-20">
                                    <Button onClick={seeProductsByTags} variant="plain">View products with matching
                                        tags </Button>
                                </div>
                            </LegacyStack>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="Displayonallproducts  "
                        title="Display on all products "
                        description="Universal display is not supported by Shop app, tags are still required. "
                    >
                        <Card>
                            <FormLayout>
                                <FormLayout.Group>
                                    <Checkbox
                                        name="universal"
                                        label="Display on all products, "
                                        checked={chart.universal}
                                        onChange={(newValue) => {
                                            handleChartChange('universal', newValue);
                                        }}
                                    />

                                </FormLayout.Group>
                            </FormLayout>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.AnnotatedSection
                        id="Image"
                        title="Image"
                        description="You can add an image to your chart.  You are able to upload your own image to
                    illustrate to your customers where these sizes are located. "
                    >
                        <Card>
                            {loading &&
                                <div>
                                    <Spinner accessibilityLabel="Spinner example" size="large"/>
                                </div>
                            }
                            <FormLayout>
                                {!chart.image_public_url &&
                                    <FormLayout.Group>
                                        <DropZone allowMultiple={false} onDrop={handleDropZoneDrop}>
                                            {uploadedFile}
                                            {fileUpload}
                                        </DropZone>
                                    </FormLayout.Group>
                                }

                                {imageError &&
                                    <div className="Polaris-Labelled__Error">
                                        <div id=":r4k:Error" className="Polaris-InlineError">
                                            <div className="Polaris-InlineError__Icon"><span className="Polaris-Icon"><svg
                                                viewBox="0 0 20 20" className="Polaris-Icon__Svg" focusable="false"
                                                aria-hidden="true"><path
                                                d="M10 6a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z"></path><path
                                                d="M11 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"></path><path fill-rule="evenodd"
                                                                                                     d="M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"></path></svg></span>
                                            </div>
                                            {imageError}
                                        </div>
                                    </div>
                                }


                                {(!chartId) &&
                                    <FormLayout.Group>
                                        <strong>Please save chart first before uploading an image.</strong>
                                    </FormLayout.Group>
                                }

                                {chart.image_public_url &&
                                    <>
                                        <FormLayout.Group>
                                            <Thumbnail
                                                source={chart.image_public_url}
                                                alt="chart image thumbnail"
                                            />
                                        </FormLayout.Group>
                                        <FormLayout.Group>
                                            <Button variant="plain" onClick={deleteImage}>Remove image</Button>;
                                        </FormLayout.Group>
                                    </>

                                }

                                {chart.image_public_url &&
                                    <FormLayout.Group>
                                        <Select
                                            label="Position of the image"
                                            options={[
                                                {label: 'Top of the chart', value: 'top'},
                                                {label: 'Bottom of the chart', value: 'bottom'},
                                                {label: 'Left to the chart', value: 'left'},
                                                {label: 'Right to the chart', value: 'right'},
                                            ]}
                                            onChange={handleImagePosition}
                                            value={chart.image_position}
                                        />
                                    </FormLayout.Group>
                                }

                            </FormLayout>
                            <div>
                                <br/>
                            </div>
                            <div className="Polaris-Choice__Descriptions">
                                <div className="Polaris-Choice__HelpText">
                                    <span className="Polaris-Text--root Polaris-Text--subdued"> This feature is not supported by Shop App. You can still add images to Shop App using HTML </span>
                                </div>
                            </div>
                        </Card>
                    </Layout.AnnotatedSection>
                    <Layout.Section>
                        <LegacyCard title="Size Chart Editor">
                            <LegacyCard.Section>
                                <p>
                                    Now you can add your sizing information. You can manually type the information into
                                    the
                                    table below or import your data using the import link at the top right of this
                                    section.
                                </p>
                                <p>
                                    <br/>
                                    To add more rows or columns, hover between cells and click the green highlighted
                                    area.

                                </p>
                                <div className="mt-20 mb-20">
                                    <Divider borderColor="border"/>
                                </div>
                                <Text variant="headingSm" as="h6">
                                    Headers
                                </Text>
                                <div className="mt-10">
                                    <p>
                                        You can choose which rows and columns you want to display as headers.
                                        By ticking the boxes below, your chosen headers will be displayed in bold text.
                                    </p>
                                </div>
                            </LegacyCard.Section>
                            <LegacyCard.Section>
                                <div style={{marginLeft: '50px', marginTop: "15px"}}>
                                    <LegacyStack distribution="fillEvenly">
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <img src="/images/top.png"
                                                 style={{marginRight: '8px'}}/>
                                            <Checkbox
                                                name="headers.top"
                                                label="Top row"
                                                checked={chart.top}
                                                onChange={(newValue) => {
                                                    handleChartChange('top', newValue);
                                                }}
                                            />
                                        </div>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <img src="/images/bottom.png"
                                                 style={{marginRight: '8px'}}/>
                                            <Checkbox
                                                name="headers.bottom"
                                                label="Bottom row"
                                                checked={chart.bottom}
                                                onChange={(newValue) => {
                                                    handleChartChange('bottom', newValue);
                                                }}
                                            />
                                        </div>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <img src="/images/left.png"
                                                 style={{marginRight: '8px'}}/>
                                            <Checkbox
                                                name="headers.left"
                                                label="Left column"
                                                checked={chart.left}
                                                onChange={(newValue) => {
                                                    handleChartChange('left', newValue);
                                                }}
                                            />
                                        </div>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <img src="/images/right.png"
                                                 style={{marginRight: '8px'}}/>
                                            <Checkbox
                                                name="headers.right"
                                                label="Right column"
                                                checked={chart.right}
                                                onChange={(newValue) => {
                                                    handleChartChange('right', newValue);
                                                }}
                                            />
                                        </div>
                                    </LegacyStack>
                                </div>
                            </LegacyCard.Section>
                            <LegacyCard.Section>

                                <CTableEditor
                                    tableData={chart.data}
                                    headers={{
                                        top: chart.top,
                                        bottom: chart.bottom,
                                        left: chart.left,
                                        right: chart.right,
                                    }}
                                    onChange={handleTableChange}
                                />
                            </LegacyCard.Section>
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
                <div style={{paddingBottom: '25px'}}></div>
        </Page>
);
}

export default ChartForm;
